import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useLang } from "../i18n/LanguageContext";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function FaqPage() {
  const { t } = useLang();
  return (
    <main data-testid="faq-page">
      <Seo title={t.seo.faq.title} desc={t.seo.faq.desc} />
      <PageHero eyebrow={t.faq.eyebrow} title={t.faq.title} sub={t.faq.sub} />

      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {t.faq.items.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-sand/50">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif text-lg font-medium text-espresso hover:text-terracotta"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm sm:text-base leading-relaxed text-espresso/75">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal className="mt-14 text-center">
            <Link
              to="/contact"
              data-testid="faq-contact-button"
              className="group inline-flex items-center gap-2 rounded-full bg-espresso px-8 py-4 text-base font-semibold text-cream transition-colors duration-300 hover:bg-terracotta active:scale-95"
            >
              {t.common.contactUs}
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
